<template>
  <div v-if="dataItem.organization" id="service-provider">
    <h4>
      <router-link
        :to="{
          name: 'Organization',
          params: {
            id: dataItem.organization.id,
            name: this.$options.filters.slugg(dataItem.organization.name), // eslint-disable-line
          },
        }"
        :aria-label="'view information for ' + dataItem.organization.name"
      >
        {{ dataItem.organization.name }}
      </router-link>
    </h4>
    <div>{{ dataItem.organization.description | trunc(100, '...') }}</div>
    <div>{{ dataItem.organization.logo }}</div>
    <b-list-group class="mt-2">
      <b-list-group-item v-if="dataItem.organization.url" class="p-0 border-0 bg-light">
        <b-icon icon="globe" class="mr-2"></b-icon>
        <a :href="dataItem.organization.url" itemprop="url">
          {{ dataItem.organization.name }} website
        </a>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
import slugg from '@/filters/sluggify.js'
import trunc from '@/filters/trunc'

export default {
  name: 'OrganisationInfo',
  filters: {
    trunc,
    slugg,
  },
  props: {
    dataItem: {
      type: Object,
      default() {
        return {}
      },
    },
  },
}
</script>
